"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**Arregla el problema con las librearias que han sido exportadas con babel 5 o con el plugin babel-plugin-add-module-exports, obteniendo el default del modulo.
 *
 * Para utilizar la función en lugar de escribir;
 * import moize from "moize";
 *
 * Escriba;
 * import * as _moize from "moize";
 * const moize = interopRequireDefault(_moize);
 */
function interopRequireDefault(module) {
    var obj = module;
    return obj.default ? obj.default : obj;
}
exports.interopRequireDefault = interopRequireDefault;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJvcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9pbnRlcm9wLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQ0E7Ozs7Ozs7O0dBUUc7QUFDSCwrQkFBeUMsTUFBc0I7SUFDM0QsSUFBTSxHQUFHLEdBQUcsTUFBYSxDQUFDO0lBQzFCLE9BQU8sR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDO0FBQzNDLENBQUM7QUFIRCxzREFHQyJ9


//////////////////
// WEBPACK FOOTER
// ./~/filtermatrix/~/keautils/dist/interop.js
// module id = 292
// module chunks = 0